var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M11.218 3.748l-.025.005C9.016 4.235 7.388 6.177 7.388 8.5v7.75c0 1.574.747 2.973 1.906 3.861C8.36 19.825 7.527 19.2 7 18.286l-3.875-6.712c-1.105-1.913-.45-4.36 1.464-5.464l3.464-2c.999-.576 2.143-.673 3.165-.362z",
    transform: "translate(-280 -610) translate(40 609) translate(240 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M9.113 8.5v7.75c0 1.733 1.404 3.137 3.137 3.137h4c1.733 0 3.137-1.404 3.137-3.137V8.5c0-1.733-1.404-3.138-3.137-3.138h-4c-1.733 0-3.137 1.405-3.137 3.138zm7.137-4.862c2.685 0 4.863 2.177 4.863 4.862v7.75c0 2.685-2.178 4.863-4.863 4.863h-4c-2.685 0-4.862-2.178-4.862-4.863V8.5c0-2.685 2.177-4.862 4.862-4.862h4z",
    transform: "translate(-280 -610) translate(40 609) translate(240 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M15.75 10.85c.828 0 1.5.672 1.5 1.5v3c0 .828-.672 1.5-1.5 1.5h-3c-.828 0-1.5-.672-1.5-1.5v-3c0-.828.672-1.5 1.5-1.5h3zM15 7.475c.414 0 .75.336.75.75s-.336.75-.75.75h-3c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3z",
    transform: "translate(-280 -610) translate(40 609) translate(240 1)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.27ee7a36.svg";
export { ForwardRef as ReactComponent };